module.exports = __webpack_public_path__ + "ef96869249182ecf79784094aa097f9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_large_x1/public/picture/Stanley.jpg
// module id = 481
// module chunks = 0